if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add("sticky-atc-bar-enabled");

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          ".f-main-product-form"
        );
        this.container = this.closest(".sticky-atc-bar");
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']"
        );
        this.position = this.container.dataset.position || 'bottom';

        // Add position class to body for CSS targeting
        if (this.position === 'top') {
          document.body.classList.add('sticky-atc-bar-top');
        }

        // Find the product information section for top positioning
        this.productInfoSection = document.querySelector(
          ".f-product-single__blocks, .f-product-single__info, product-info"
        );

        // Initialize scroll state management
        this.isBarVisible = false;
        this.scrollTimeout = null;
        this.hasScrolled = false;
        
        // Get mobile navigation element
        this.mobileNavElement = document.querySelector('.sticky-atc-bar__mobile-nav--mobile');

        this.variantData = this.getVariantData();
        this.select = this.querySelector("select");

        try {
          this.init();
          
          // Initialize navigation functionality after init
          this.initNavigation();
        } catch (error) {
          console.error('Error in init():', error);
        }
        if (this.select) {
          this.select.addEventListener("change", () => {
          const mainVariantPicker =
            this.mainProduct.querySelector("variant-picker");
          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect
          ).value;
          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId)
          );

          if (mainVariantPicker) {
            Array.from(
              mainVariantPicker.querySelectorAll(
                "select, .variant-picker__option-values"
              ),
              (element, index) => {
                const variantOptionVal = this.currentVariant.options[index];
                switch (element.tagName) {
                  case "SELECT":
                    element.value = variantOptionVal;
                    break;
                  case "DIV":
                    Array.from(element.querySelectorAll("input")).forEach(
                      (radio) => {
                        if (radio.value === variantOptionVal) {
                          radio.checked = true;
                        }
                      }
                    );
                    break;
                }
              }
            );
            mainVariantPicker.dispatchEvent(new Event("change"));
          }

          // Update the hidden input field if it exists
          const hiddenInput = this.querySelector('input[name="id"]');
          if (hiddenInput) {
            hiddenInput.value = this.currentVariant.id;
          }

          this.updatePrice();
          this.updateButton(!this.currentVariant.available, "", false);
          
          // Force update button text to ensure it's always updated
          setTimeout(() => {
            this.updateButtonText();
          }, 50);
          });
        } else {
          // If no select element, set the current variant to the default
          this.currentVariant = this.getCurrentVariant();
        }
      }

      getVariantData() {
        try {
          const jsonScript = this.container.querySelector('[type="application/json"]');
          if (jsonScript) {
            this.variantData =
              this.variantData ||
              JSON.parse(jsonScript.textContent);
          } else {
            console.warn('No variant data JSON script found');
            this.variantData = this.variantData || {};
          }
        } catch (error) {
          console.error('Error parsing variant data:', error);
          this.variantData = this.variantData || {};
        }
        return this.variantData;
      }

      init() {
        // Initialize sections array for navigation
        this.sections = [];
        
        // For bottom position, always show the bar
        if (this.position === 'bottom') {
          this.container.classList.add("sticky-atc-bar--show");
          // If no product form actions, don't set up intersection observer
          if (!this.productFormActions) {
            return;
          }
        }
        
        // For top position, don't show the bar initially - let intersection observer control visibility
        if (this.position === 'top') {
          // Ensure the bar starts hidden
          this.container.classList.remove("sticky-atc-bar--show");
          
          // If no product info section, don't set up intersection observer
          if (!this.productInfoSection) {
            return;
          }
        }
        this.productId = this.dataset.productId;
        const isMobile = window.matchMedia("(max-width: 639px)");

        try {
          // Chrome & Firefox
          isMobile.addEventListener("change", this.checkDevice.bind(this));
        } catch (err) {
          try {
            // Safari
            isMobile.addListener(this.checkDevice.bind(this));
          } catch (e2) {
            console.error(e2);
          }
        }

        // Initial check
        this.checkDevice(isMobile);

        const headerHeight = window.FoxThemeSettings.headerHeight || 80;
        let rootMargin, threshold;
        
        if (this.position === 'top') {
          // For top position, we want to show when the product info section is completely out of view
          rootMargin = `-${headerHeight}px 0px 0px 0px`;
          threshold = 0; // Trigger when any part goes out of view
        } else {
          // For bottom position, use the original logic
          rootMargin = `-${headerHeight}px 0px 0px 0px`;
          threshold = 1; // Trigger when fully visible
        }
        
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              let shouldShow;
              if (this.position === 'top') {
                // For top position, show when product info section is not intersecting (scrolled past)
                shouldShow = !entry.isIntersecting;
              } else {
                // For bottom position, show when product form is not fully visible
                shouldShow = entry.intersectionRatio !== 1;
              }
              
              this.updateBarVisibility(shouldShow);
            });
          },
          { threshold, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        if (this.position === 'top' && this.productInfoSection) {
          // For top position, observe the product information section
          this.observer.observe(this.productInfoSection);
          this.observeTarget = this.productInfoSection;
        } else if (this.productFormActions) {
          // For bottom position, use the original logic
          this.observer.observe(this.productFormActions);
          this.observeTarget = this.productFormActions;
        }
      }

      checkDevice(e) {
        setTimeout(() => {
          const sectionHeight = this.clientHeight + "px";
          document.documentElement.style.setProperty(
            "--f-sticky-atc-bar-height",
            sectionHeight
          );
        }, 100);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          "product-form-sticky-atc-bar"
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '.sticky-atc-bar__button-text'
        );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text && text !== "") {
            addButtonText.textContent = text;
          } else {
            // If no specific text provided, show sold out
            addButtonText.textContent = window.FoxThemeStrings.soldOut || 'Sold out';
          }
        } else {
          addButton.removeAttribute("disabled");
          // Always update button text with current price when enabled
          this.updateButtonText();
        }
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect
        ).value;
        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(selectedVariantId)
        );
        fetch(
          `${this.getAttribute("data-url")}?variant=${
            this.currentVariant.id
          }&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );
            const newQuantity = parsedHTML.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      updatePrice() {
        const classes = {
          onSale: "f-price--on-sale",
          soldOut: "f-price--sold-out",
        };
        const selectors = {
          priceWrapper: ".f-price",
          salePrice: ".f-price-item--sale",
          compareAtPrice: [".f-price-item--regular"],
          unitPrice: ".f-price__unit",
          saleBadge: ".f-price__badge-sale",
          saleAmount: "[data-sale-value]",
        };
        const money_format = window.FoxThemeSettings.money_format;
        const { priceWrapper, salePrice, unitPrice, compareAtPrice } =
          queryDomNodes(selectors, this);

        const { compare_at_price, price, unit_price_measurement } =
          this.currentVariant;

        const onSale = compare_at_price && compare_at_price > price;
        const soldOut = !this.currentVariant.available;

        if (onSale) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        if (soldOut) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
        if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

        if (
          compareAtPrice &&
          compareAtPrice.length &&
          compare_at_price > price
        ) {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML = formatMoney(compare_at_price, money_format))
          );
        } else {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = formatMoney(price, money_format))
          );
        }

        if (unit_price_measurement && unitPrice) {
          unitPrice.classList.remove("f-hidden");
          const unitPriceContent = `<span>${formatMoney(
            this.currentVariant.unit_price,
            money_format
          )}</span>/<span data-unit-price-base-unit>${getBaseUnit(
            this.currentVariant
          )}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else if (unitPrice) {
          unitPrice.classList.add("f-hidden");
        }

        // Update button text with new price
        this.updateButtonText();
      }

      updateButtonText() {
        const buttonText = this.querySelector('.sticky-atc-bar__button-text');
        
        if (!buttonText) {
          return;
        }

        // If no current variant, use the default/selected variant
        if (!this.currentVariant) {
          this.currentVariant = this.getCurrentVariant();
        }

        if (!this.currentVariant) {
          buttonText.textContent = window.FoxThemeStrings.soldOut || 'Sold out';
          return;
        }

        const money_format = window.FoxThemeSettings.money_format;
        const price = formatMoney(this.currentVariant.price, money_format);
        
        if (this.currentVariant.available) {
          buttonText.innerHTML = `Add to bag - <span class="f-price">${price}</span>`;
        } else {
          buttonText.textContent = window.FoxThemeStrings.soldOut || 'Sold out';
        }
      }

      getCurrentVariant() {
        // If there's a select element, get the selected variant
        if (this.select) {
          const selectedVariantId = this.select.value;
          return this.variantData.find(variant => variant.id === Number(selectedVariantId));
        }
        
        // If no select element (single variant), use the first/default variant
        return this.variantData[0];
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
          const isMainProduct =
            evt.data.sectionId === this.mainProduct.dataset.section;
          if (!isMainProduct) return;
          this.currentVariant = evt.data.variant;
          if (this.currentVariant) {
            this.container.classList.remove("f-hidden");
            if (variantInput) {
              variantInput.value = evt.data.variant.id;
            }
            this.updatePrice();
            this.updateButton(!evt.data.variant.available, "", false);
          } else {
            this.container.classList.add("f-hidden");
          }

          this.updateQuantityInput();
        });
      }

      initNavigation() {
        this.navList = document.getElementById('sticky-nav-list');
        this.mobileNavList = document.getElementById('sticky-mobile-nav-list');
        
        if (!this.navList && !this.mobileNavList) {
          return;
        }
        
        // Find all sections with navigation anchor data attributes
        const sectionsWithAnchors = document.querySelectorAll('[data-nav-anchor]');
        
        // Don't show navigation if there are less than 2 items
        if (sectionsWithAnchors.length < 2) {
          if (this.navList) {
            this.navList.style.display = 'none';
          }
          if (this.mobileNavList) {
            this.mobileNavList.style.display = 'none';
          }
          return;
        }
        
        sectionsWithAnchors.forEach(section => {
          const anchorText = section.dataset.navAnchor;
          const anchorId = section.dataset.navAnchorId || section.id || `section-${Math.random().toString(36).substr(2, 9)}`;
          
          // Ensure the section has an ID for anchoring
          if (!section.id) {
            section.id = anchorId;
          }
          
          // Create desktop navigation link
          if (this.navList) {
            const navItem = document.createElement('li');
            const navLink = document.createElement('a');
            navLink.href = `#${section.id}`;
            navLink.className = 'sticky-atc-bar__nav-link';
            navLink.dataset.section = section.id;
            navLink.textContent = anchorText;
            
            navItem.appendChild(navLink);
            this.navList.appendChild(navItem);
          }
          
          // Create mobile navigation link
          if (this.mobileNavList) {
            const mobileNavItem = document.createElement('li');
            const mobileNavLink = document.createElement('a');
            mobileNavLink.href = `#${section.id}`;
            mobileNavLink.className = 'sticky-atc-bar__mobile-nav-link';
            mobileNavLink.dataset.section = section.id;
            mobileNavLink.textContent = anchorText;
            
            mobileNavItem.appendChild(mobileNavLink);
            this.mobileNavList.appendChild(mobileNavItem);
          }
          
          // Add to sections array for scroll tracking (use desktop link as primary)
          this.sections.push({
            id: section.id,
            element: section,
            link: this.navList ? this.navList.querySelector(`a[data-section="${section.id}"]`) : this.mobileNavList.querySelector(`a[data-section="${section.id}"]`),
            mobileLink: this.mobileNavList ? this.mobileNavList.querySelector(`a[data-section="${section.id}"]`) : null
          });
          
        });
        
        // If no sections found, add a fallback navigation
        if (sectionsWithAnchors.length === 0) {
          const productInfoSection = document.querySelector('.f-product-single__blocks, .f-product-single__info, product-info');
          
          if (productInfoSection && this.navList) {
            const fallbackNav = document.createElement('li');
            const fallbackLink = document.createElement('a');
            fallbackLink.href = '#ProductInfo-' + this.sectionId;
            fallbackLink.className = 'sticky-atc-bar__nav-link';
            fallbackLink.dataset.section = 'ProductInfo-' + this.sectionId;
            fallbackLink.textContent = 'Product Info';
            fallbackNav.appendChild(fallbackLink);
            this.navList.appendChild(fallbackNav);
          }
          
          if (productInfoSection && this.mobileNavList) {
            const mobileFallbackNav = document.createElement('li');
            const mobileFallbackLink = document.createElement('a');
            mobileFallbackLink.href = '#ProductInfo-' + this.sectionId;
            mobileFallbackLink.className = 'sticky-atc-bar__mobile-nav-link';
            mobileFallbackLink.dataset.section = 'ProductInfo-' + this.sectionId;
            mobileFallbackLink.textContent = 'Product Info';
            mobileFallbackNav.appendChild(mobileFallbackLink);
            this.mobileNavList.appendChild(mobileFallbackNav);
          }
          
          // Add to sections array
          if (productInfoSection) {
            this.sections.push({
              id: 'ProductInfo-' + this.sectionId,
              element: productInfoSection,
              link: this.navList ? this.navList.querySelector(`a[data-section="ProductInfo-${this.sectionId}"]`) : null,
              mobileLink: this.mobileNavList ? this.mobileNavList.querySelector(`a[data-section="ProductInfo-${this.sectionId}"]`) : null
            });
          }
        }
        
        // Center mobile navigation if less than 5 links
        if (this.mobileNavList && sectionsWithAnchors.length < 5) {
          this.mobileNavList.classList.add('centered');
        }
        
        // Add smooth scroll with offset to navigation links
        this.addSmoothScrollToLinks();
        
        // Add scroll event listener
        window.addEventListener('scroll', this.handleScroll.bind(this));
        
        // Initial check
        this.handleScroll();
      }

      addSmoothScrollToLinks() {
        const scrollOffset = 100; // Offset in pixels from the top
        
        // Handle desktop navigation links
        if (this.navList) {
          const desktopLinks = this.navList.querySelectorAll('a[href^="#"]');
          desktopLinks.forEach(link => {
            link.addEventListener('click', (e) => {
              e.preventDefault();
              const targetId = link.getAttribute('href').substring(1);
              const targetElement = document.getElementById(targetId);
              
              if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - scrollOffset;
                
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            });
          });
        }
        
        // Handle mobile navigation links
        if (this.mobileNavList) {
          const mobileLinks = this.mobileNavList.querySelectorAll('a[href^="#"]');
          mobileLinks.forEach(link => {
            link.addEventListener('click', (e) => {
              e.preventDefault();
              const targetId = link.getAttribute('href').substring(1);
              const targetElement = document.getElementById(targetId);
              
              if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - scrollOffset;
                
                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            });
          });
        }
      }

      updateBarVisibility(shouldShow) {
        // Clear any existing timeout
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }

        // Only update if the state actually changes
        if (shouldShow !== this.isBarVisible) {
          this.scrollTimeout = setTimeout(() => {
            this.isBarVisible = shouldShow;
            
            if (shouldShow) {
              this.container.classList.add("sticky-atc-bar--show");
              
              // Show mobile navigation bar if it exists and has navigation items
              if (this.mobileNavElement && this.mobileNavList && this.mobileNavList.children.length >= 2) {
                this.mobileNavElement.classList.add("sticky-atc-bar__mobile-nav--show");
                document.body.classList.add("sticky-atc-bar-mobile-nav-visible");
              }
              
              // Padding is handled by CSS positioning below header
            } else {
              this.container.classList.remove("sticky-atc-bar--show");
              
              // Hide mobile navigation bar
              if (this.mobileNavElement) {
                this.mobileNavElement.classList.remove("sticky-atc-bar__mobile-nav--show");
                document.body.classList.remove("sticky-atc-bar-mobile-nav-visible");
              }
              
              // Don't remove the scrolled class - keep padding to prevent layout shifts
            }
          }, 100); // Delay to prevent rapid toggling and glitching
        }
      }

      handleScroll() {
        const scrollPosition = window.scrollY + 200; // Offset for better section detection
        
        // Check if we're at the very top of the page
        if (this.position === 'top' && window.scrollY < 50) {
          // Remove any padding when at the top
          if (this.hasScrolled) {
            this.hasScrolled = false;
            document.body.classList.remove("sticky-atc-bar-scrolled");
          }
        }
        
        let activeSection = null;
        
        this.sections.forEach(section => {
          const sectionTop = section.element.offsetTop;
          const sectionBottom = sectionTop + section.element.offsetHeight;
          
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
            activeSection = section;
          }
        });

        // Remove active class from all navigation links (both desktop and mobile)
        this.sections.forEach(section => {
          if (section.link) {
            section.link.classList.remove('active');
          }
          if (section.mobileLink) {
            section.mobileLink.classList.remove('active');
          }
        });
        
        // If no section is active (scrolled past all sections), don't highlight anything
        if (!activeSection) {
          const lastSection = this.sections[this.sections.length - 1];
          if (lastSection) {
            const lastSectionBottom = lastSection.element.offsetTop + lastSection.element.offsetHeight;
            // If we've scrolled past the last section, don't highlight anything
            if (scrollPosition >= lastSectionBottom) {
              return; // No active section - all links will remain without active class
            }
          }
        }

        // Add active class to the current section's link (both desktop and mobile)
        if (activeSection) {
          if (activeSection.link) {
            activeSection.link.classList.add('active');
          }
          if (activeSection.mobileLink) {
            activeSection.mobileLink.classList.add('active');
          }
        }
      }
    }
  );
}
